import { useEffect, useMemo, useState } from 'react';

export function useStorageClassFormValidation(
  watchValue: unknown,
  pricingActive: boolean,
  collectMissingIndexes: (value: unknown) => number[],
  requiredMessage: string,
) {
  const [showErrors, setShowErrors] = useState(false);

  useEffect(() => {
    setShowErrors(false);
  }, [watchValue]);

  const rules = useMemo(
    () => [
      {
        validator(value: unknown, callback: (message?: string) => void) {
          if (pricingActive) {
            callback();
            return;
          }
          if (collectMissingIndexes(value).length > 0) {
            setShowErrors(true);
            callback(requiredMessage);
            return;
          }
          callback();
        },
      },
    ],
    [collectMissingIndexes, pricingActive, requiredMessage],
  );

  const missingIndexes = useMemo(() => {
    if (!showErrors || pricingActive) return new Set<number>();
    return new Set(collectMissingIndexes(watchValue));
  }, [collectMissingIndexes, pricingActive, showErrors, watchValue]);

  const singleDiskError = showErrors && !pricingActive && collectMissingIndexes(watchValue).length > 0;

  return { rules, missingIndexes, singleDiskError };
}
